// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FR4h","colMin":"styles_colMin__LSeW4"};